module.exports = __webpack_public_path__ + "static/registr-2.dd22a0ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/registr/registr-2.svg
// module id = 144
// module chunks = 168707334958949